export default {slug_name:'ui_plugin_demo',version:'0.0.1',author:'Answer.dev'};